<template>
  <vxe-grid
    ref="vxeGrid"
    size="small"
    border
    resizable
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :header-cell-style="
      () => {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    "
  />
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('INDEX.sample_barcode') || '样品条码',
          field: 'sampleBarcode',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.sample_style_no') || '样品款号',
          field: 'sampleStyleNo',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.sample_name') || '样品名称',
          field: 'sampleName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.stock_form_qty') || '库存数量',
          field: 'invNum',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
    }
  },
}
</script>
